"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = exports.getBatchApplicableContracts = exports.assignFees = exports.typeahead = exports.rolloverCredits = exports.deleteAttachment = exports.getAttachments = exports.getProjects = exports.unlinkContracts = exports.updateLinkedContracts = exports.linkContracts = exports.getAccountContracts = exports.deleteContract = exports.getContract = exports.update = exports.create = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var base = '/api/contract';
function create(contractFormData) {
    return api_1.default.post(base, contractFormData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function update(oldContractData, contractFormData) {
    var contractData = contractFormData;
    return api_1.default.put("".concat(base, "/").concat(oldContractData.id), contractData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function getContract(contractId, opts) {
    if (opts === void 0) { opts = {}; }
    return api_1.default
        .get("".concat(base, "/").concat(contractId).concat(opts.light ? "?light=".concat(opts.light) : ''))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getContract = getContract;
function deleteContract(contractId) {
    return api_1.default.delete("".concat(base, "/").concat(contractId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.deleteContract = deleteContract;
function getAccountContracts(accountId) {
    return api_1.default.get("".concat(base, "/account/").concat(accountId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAccountContracts = getAccountContracts;
function linkContracts(contractId, contractIds, linkReason) {
    return api_1.default
        .post("".concat(base, "/").concat(contractId, "/linked-contracts"), {
        contractIds: contractIds,
        linkReason: linkReason || undefined,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.linkContracts = linkContracts;
function updateLinkedContracts(contractAId, contractBId, linkReason) {
    var url = "".concat(base, "/").concat(contractAId, "/linked-contracts/").concat(contractBId);
    return api_1.default.put(url, { linkReason: linkReason }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateLinkedContracts = updateLinkedContracts;
function unlinkContracts(contractAId, contractBId) {
    var url = "".concat(base, "/").concat(contractAId, "/linked-contracts/").concat(contractBId);
    return api_1.default.delete(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.unlinkContracts = unlinkContracts;
function getProjects(contractId, page, limit) {
    if (page === void 0) { page = 1; }
    if (limit === void 0) { limit = 10; }
    return api_1.default.get("".concat(base, "/").concat(contractId, "/projects?page=").concat(page, "&limit=").concat(limit)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getProjects = getProjects;
function getAttachments(contractId) {
    return api_1.default.get("".concat(base, "/").concat(contractId, "/attachments")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAttachments = getAttachments;
function deleteAttachment(fileId) {
    return api_1.default.delete("".concat(base, "/attachments/").concat(fileId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.deleteAttachment = deleteAttachment;
function rolloverCredits(fromId, toId) {
    return api_1.default.put("".concat(base, "/").concat(fromId, "/rollover-credits/").concat(toId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.rolloverCredits = rolloverCredits;
function typeahead(q, parentAccountId) {
    var queryParams = query_string_1.default.stringify({ q: q, parentAccountId: parentAccountId });
    return api_1.default.get("".concat(base, "/typeahead?").concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.typeahead = typeahead;
function assignFees(_a) {
    var fees = _a.fees, contractId = _a.contractId;
    return api_1.default.put("".concat(base, "/assign-fees"), { fees: fees, contractId: contractId }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.assignFees = assignFees;
function getBatchApplicableContracts(feeIds) {
    return api_1.default.put("".concat(base, "/bach-applicable-contracts"), { feeIds: feeIds }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getBatchApplicableContracts = getBatchApplicableContracts;
function search(query) {
    return api_1.default.post('/api/contract/search', query).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.search = search;
var api = {
    create: create,
    update: update,
    getContract: getContract,
    deleteContract: deleteContract,
    getAccountContracts: getAccountContracts,
    linkContracts: linkContracts,
    updateLinkedContracts: updateLinkedContracts,
    unlinkContracts: unlinkContracts,
    getProjects: getProjects,
    getAttachments: getAttachments,
    deleteAttachment: deleteAttachment,
    rolloverCredits: rolloverCredits,
    typeahead: typeahead,
    assignFees: assignFees,
    getBatchApplicableContracts: getBatchApplicableContracts,
    search: search,
};
exports.default = api;
